import { Moon, Sun } from "lucide-react";
import { cn } from "../lib/cn";
import { useTheme } from "../lib/theme";

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggle } = useTheme();
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={theme === "dark" ? "Switch to light theme" : "Switch to dark theme"}
      title={theme === "dark" ? "Light theme" : "Dark theme"}
      className={cn(
        "ring-focus inline-flex h-8 w-8 items-center justify-center rounded-md border border-line bg-surface-2 text-ink-muted transition-colors hover:bg-surface-3 hover:text-ink",
        className,
      )}
    >
      {theme === "dark" ? <Sun size={15} /> : <Moon size={15} />}
    </button>
  );
}
